module.exports = __webpack_public_path__ + "img/SharpnessEnhancement04.ea6a69ac.png";